export default {
  changeLocaleTitle: "语言切换 {type}"
};
